import { Map } from 'immutable';
import { types } from '@saucelabs/sl-module-performance';

import { FILMSTRIP_SNAPSHOT_Y_AXIS_START_POINT } from '../filmstrip/constants';

const initialState = Map({
  loadingFilmStrip: false,
  filmStrip: [],
  filmstripMetricsHistory: Map(),
});

const filmStripReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_FILMSTRIP.REQUEST: {
      return state.set('loadingFilmStrip', true);
    }
    case types.FETCH_FILMSTRIP.SUCCESS: {
      // images are not necessarily sent in correct order
      const sorted = payload
        .map((image) => ({
          snapshot: image.snapshot,
          ts: image.relativeTs,
          cy: FILMSTRIP_SNAPSHOT_Y_AXIS_START_POINT,
        }))
        .sort((prev, curr) => prev.ts - curr.ts);
      return state.withMutations((newState) => {
        newState
          .set('filmStrip', sorted)
          .set('loadingFilmStrip', false);
      });
    }
    case types.FETCH_FILMSTRIP.FAILURE:
      return state.set('loadingFilmStrip', false);
    default:
      return state;
  }
};

export default filmStripReducer;
export { initialState };
